<script setup lang="ts">
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
</script>

<template>
   <section>
      <div class="row">
         <div class="col-half col-half--small-gap">
            <div>{{ $t('job-board.settings.logo_job_board') }}</div>
            <small>{{ $t('job-board.settings.logo_job_board_description') }}</small>
            <MediaSelector class="max-width-200px" v-model="jobBoard.logo_image_url" :id="jobBoard.id" />
         </div>
         <div class="col-half col-half--small-gap">
            <div>{{ $t('job-board.settings.favicon_job_board') }}</div>
            <small>{{ $t('job-board.settings.favicon_job_board_description') }}</small>
            <MediaSelector class="max-width-200px" v-model="jobBoard.favicon_url" :id="jobBoard.id" />
         </div>
      </div>
   </section>
</template>

<style scoped lang="scss">
:deep(.media-selector.max-width-200px) {
   max-width: 200px;
}
</style>
